import React from 'react';
import Reveal from 'react-reveal';
import Layout from "../components/layouts";
import { Parallax } from 'react-parallax';
import cfgPoster from "../images/cfg-poster-2025.png";
import cfgTitle from "../images/cfg-title.png";
import cfg1 from "../images/cfg-1.jpeg";
import cfg2 from "../images/cfg-2.jpeg";
import cfg3 from "../images/cfg-3.jpeg";
import cfgHeader from "../images/cfg-header.jpeg";
import kitbashedLogo from "../images/Kitbashed_Logo_Black.png";
import cfgArtistDowntown from "../images/CFG_Artist_Downtown.jpg";
import cfgArtistLincolnHeights from "../images/CFG_Artist_LincolnHeights.jpeg";
import cfgArtistLittleTokyo from "../images/CFG_Artist_LittleTokyo.jpg";
import cfgArtistSanFernando from "../images/CFG_Artist_SanFernando.jpeg";
import cfgArtistSouthCentral from "../images/CFG_Artist_SouthCentral.jpg";
import cfgArtistWillowbrook from "../images/CFG_Artist_Willowbrook.jpg";
import cfgArtistWinnerBanner from '../images/CFG_PO_FinalistsBanner_GIdotORG.jpg';
const CFGContest = () => {
  return (
    <Layout navBg>
    <div className="cfg-contest-page">
        <Parallax className="page-header" bgImage={cfgHeader} strength={400}>
            <div style={{height: '100vh', maxHeight: '600px'}}>
                <div className="page-header-overlay" />
                <div className="cfg-header-content">
                    <Reveal effect="animated fadeInUp" duration={1500}>
                        <div className="cfg-presented-by">Camp Flog Gnaw x POSTed Office</div>
                    </Reveal>
                    <Reveal effect="animated fadeInUp" delay={300} duration={1500}>
                        <img className="cfg-title-image" src={cfgTitle} alt="Camp Flog Gnaw - Call to Artists" />
                    </Reveal>
                    <Reveal effect="animated fadeInUp" delay={800} duration={1500}>
                        <a href="#winners" className="cfg-cta-button">
                            See Finalists
                        </a>
                    </Reveal>
                </div>
            </div>
        </Parallax>
        
        <div className="cfg-contest-inner">
          <div className="cfg-contest-description">
              <Reveal effect="animated fadeInLeft" duration={1200}>
                <h1>Attention all artists!</h1>
              </Reveal>
              <Reveal effect="animated fadeInLeft" delay={200} duration={1200}>
                <p><a href="https://www.campfloggnaw.com/" target="_blank" rel="noopener noreferrer">Camp Flog Gnaw</a> and Global Inheritance are seeking Los Angeles–based illustrators, graphic designers, artists, and creatives to submit original postcard design concepts for the POSTed Office at Camp Flog Gnaw.</p>
              </Reveal>
              <Reveal effect="animated fadeInLeft" delay={400} duration={1200}>
                <p>Six artists will be selected from the submissions received to create postcards that <strong>"represent your community"</strong> - inspired by the art and culture of your neighborhood.</p>
              </Reveal>
              <Reveal effect="animated fadeInLeft" delay={600} duration={1200}>
                <p>In addition to having your community-focused artwork featured on custom printed postcards at the Camp POSTed Office – <strong>the six selected artists will receive two VIP passes to the sold-out Camp Flog Gnaw!</strong></p>
              </Reveal>
              <Reveal effect="animated fadeInLeft" delay={800} duration={1200}>
                <p>If you don't win one of the six grand prizes, another <strong>(6) Runners-up</strong> will win Camp Flog Gnaw 2025 swag bags.</p>
              </Reveal>
              <Reveal effect="animated fadeInLeft" delay={1000} duration={1200}>
                <p>Interested? Submit your art samples and portfolio <a href="#form">HERE</a>.</p>
              </Reveal>
              <Reveal effect="animated fadeInLeft" delay={1200} duration={1200}>
                <p>Eligibility: Artists, illustrators, and designers must reside in Los Angeles County to be considered. AI-generated submissions will not be accepted. <strong>Submit your artwork by 8:00pm PST on October 25th, 2025. Winning artists will be notified by October 28th, 2025</strong></p>
              </Reveal>
              <Reveal effect="animated fadeInLeft" delay={1400} duration={1200}>
                <p>The local artists of our Los Angeles communities are world class — let's share our creative culture with the rest of the world!</p>
              </Reveal>
              <Reveal effect="animated fadeInLeft" delay={400} duration={1200}>
                <p>View POSTed Office at Camp Flog Gnaw 2024 Photo Gallery <a href="https://www.flickr.com/photos/74696088@N00/albums/72177720322039946" target="_blank" rel="noopener noreferrer" className="cfg-cta-button">HERE</a></p>
              </Reveal>
          </div>
          <div className="cfg-contest-body">
            <Reveal effect="animated fadeInRight" duration={1500}>
              <img className="cfg-floating-image" src={cfgPoster} alt="Camp Flog Gnaw Poster" />
            </Reveal>
        </div>
      </div>
        
        <div className="cfg-contest-inner">
          <Reveal effect="animated fadeIn">
            <div className="cfg-contest-gallery">
              <Reveal effect="animated fadeInUp" delay={0} duration={1200}>
                <div className="cfg-contest-ex">
                  <img src={cfg1} alt="Camp Flog Gnaw Design Inspiration 1" />
                </div>
              </Reveal>
              <Reveal effect="animated fadeInUp" delay={300} duration={1200}>
                <div className="cfg-contest-ex">
                  <img src={cfg2} alt="Camp Flog Gnaw Design Inspiration 2" />
                </div>
              </Reveal>
              <Reveal effect="animated fadeInUp" delay={600} duration={1200}>
                <div className="cfg-contest-ex">
                  <img  src={cfg3} alt="Camp Flog Gnaw Design Inspiration 3" />
                </div>
              </Reveal>
            </div>
          </Reveal>
        </div>
        
        <div className="cfg-contest-inner">
          <div className="cfg-contest-description">
              <Reveal effect="animated fadeInLeft" duration={1200}>
                <h2>Ever dream of working at the POSTed Office?</h2>
              </Reveal>
              <Reveal effect="animated fadeInLeft" delay={200} duration={1200}>
                <p>We are now accepting <a href="/sign-up/volunteer" className="cfg-cta-button">volunteer applications</a> now.</p>
              </Reveal>
          </div>
        </div>
        
        <div id="winners" className="cfg-contest-inner">
          <Reveal effect="animated fadeIn">
            <div className="cfg-winners-section">
              <Reveal effect="animated fadeInUp" duration={1200}>
                <img src={cfgArtistWinnerBanner} alt="Camp Flog Gnaw x POSTed Office 2025 Finalists Banner" className="cfg-winner-banner" />
              </Reveal>
              
              <div className="cfg-artist-grid">
                <Reveal effect="animated fadeInUp" delay={0} duration={1200}>
                  <div className="cfg-artist-item">
                    <img src={cfgArtistDowntown} alt="CFG Artist - Downtown" />
                    <a 
                      href="https://app.box.com/s/sd89c9eonaupd4yj69bi6f3iaviun5fk/file/2049250499699" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="cfg-cta-button"
                    >
                      Download
                    </a>
                  </div>
                </Reveal>
                <Reveal effect="animated fadeInUp" delay={100} duration={1200}>
                  <div className="cfg-artist-item">
                    <img src={cfgArtistLincolnHeights} alt="CFG Artist - Lincoln Heights" />
                    <a 
                      href="https://app.box.com/s/sd89c9eonaupd4yj69bi6f3iaviun5fk/file/2049255095143" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="cfg-cta-button"
                    >
                      Download
                    </a>
                  </div>
                </Reveal>
                <Reveal effect="animated fadeInUp" delay={200} duration={1200}>
                  <div className="cfg-artist-item">
                    <img src={cfgArtistLittleTokyo} alt="CFG Artist - Little Tokyo" />
                    <a 
                      href="https://app.box.com/s/sd89c9eonaupd4yj69bi6f3iaviun5fk/file/2049254240924" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="cfg-cta-button"
                    >
                      Download
                    </a>
                  </div>
                </Reveal>
                <Reveal effect="animated fadeInUp" delay={300} duration={1200}>
                  <div className="cfg-artist-item">
                    <img src={cfgArtistSanFernando} alt="CFG Artist - San Fernando" />
                    <a 
                      href="https://app.box.com/s/sd89c9eonaupd4yj69bi6f3iaviun5fk/file/2049250093753" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="cfg-cta-button"
                    >
                      Download
                    </a>
                  </div>
                </Reveal>
                <Reveal effect="animated fadeInUp" delay={400} duration={1200}>
                  <div className="cfg-artist-item">
                    <img src={cfgArtistSouthCentral} alt="CFG Artist - South Central" />
                    <a 
                      href="https://app.box.com/s/sd89c9eonaupd4yj69bi6f3iaviun5fk/file/2049249830257" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="cfg-cta-button"
                    >
                      Download
                    </a>
                  </div>
                </Reveal>
                <Reveal effect="animated fadeInUp" delay={500} duration={1200}>
                  <div className="cfg-artist-item">
                    <img src={cfgArtistWillowbrook} alt="CFG Artist - Willowbrook" />
                    <a 
                      href="https://app.box.com/s/sd89c9eonaupd4yj69bi6f3iaviun5fk/file/2049254672520" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="cfg-cta-button"
                    >
                      Download
                    </a>
                  </div>
                </Reveal>
              </div>
            </div>
          </Reveal>
        </div>
    </div>
    </Layout>
);
}

export default CFGContest;
